<div class="flex-column gap pb-3">
    <app-service-settings-common
        [defaultData]="store.eprescriptionsSettings()"
        [hideShareWithOtherServicesInput]="true"
        [title]="'service.settings.eprescriptions.header'"
    >
        <ng-template #additionalContent>
            <p-divider></p-divider>
            <app-text-input
                id="pzs"
                [form]="form"
                label="service.settings.eprescriptions.pzs"
            ></app-text-input>
            <app-check-input
                id="saveToMedicationOnSend"
                [form]="form"
                label="service.settings.eprescriptions.saveToMedicationOnSend"
            ></app-check-input>
        </ng-template>
        <ng-template #footer>
            <app-action-buttons
                (primaryClickEvent)="save()"
                (secondaryClickEvent)="cancel()"
            ></app-action-buttons>
        </ng-template>
    </app-service-settings-common>

    <app-service-doctors-secrets
        [serviceId]="Number(routeParams.serviceId())"
        [secretType]="UserSecretTypeEnum.QUAL_CERT"
        [title]="'service.settings.eprescriptions.doctorsCertificates'"
    ></app-service-doctors-secrets>

    <app-service-doctors-secrets
        [serviceId]="Number(routeParams.serviceId())"
        [secretType]="UserSecretTypeEnum.SUKL_IDENTITY"
        [title]="'service.settings.eprescriptions.doctorsSecrets'"
    ></app-service-doctors-secrets>

    <app-service-certificates-settings
        [serviceId]="Number(routeParams.serviceId())"
    ></app-service-certificates-settings>
</div>
